import { render, staticRenderFns } from "./m-incorrect-format.vue?vue&type=template&id=40598276&scoped=true&"
import script from "./m-incorrect-format.vue?vue&type=script&lang=js&"
export * from "./m-incorrect-format.vue?vue&type=script&lang=js&"
import style0 from "./m-incorrect-format.vue?vue&type=style&index=0&id=40598276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40598276",
  null
  
)

export default component.exports